// A Walmart Marketplace reply (2026-10-15): Walmart allows no links but a
// written-out http(s) URL (2026-10-27), like
// eBay. The reply box warns as the agent types (and on a template insert,
// which changes the same text) and disables Send while any link remains.
// findWalmartLinks() and the sentence come from @cxhub/shared, the same ones the
// server refuses a send with (send-approved-reply.js), so the two cannot
// disagree. See docs/decisions/2026-10-15-walmart-no-links-signature.md.
import { findWalmartLinks, walmartLinkMessage } from '@cxhub/shared'

// A Walmart contact: client Walmart, or the WMT TRQ client code.
export function isWalmartReply({ client = null, trqClientCode = null } = {}) {
  return client === 'Walmart' || String(trqClientCode ?? '').toUpperCase() === 'WMT'
}

// The warning for a Walmart reply that contains a link, else null (also for
// every other client).
export function walmartLinkWarning({ client = null, trqClientCode = null, text = '' } = {}) {
  if (!isWalmartReply({ client, trqClientCode })) return null
  return walmartLinkMessage(findWalmartLinks(text))
}
